var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.17,
    height: 31.17,
    viewBox: "0 0 31.17 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zip",
    transform: "translate(-3851.359 -1912.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M3882.529,1922.357v17.39a4.421,4.421,0,0,1-4.42,4.42h-22.33a4.422,4.422,0,0,1-4.42-4.42v-22.33a4.422,4.422,0,0,1,4.42-4.42h17.39Z",
    fill: "#87a4c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M3873.169,1917.937V1913l9.36,9.36h-4.94A4.422,4.422,0,0,1,3873.169,1917.937Z",
    fill: "#7e8f9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3096",
    "data-name": "Rectangle 3096",
    width: 1.933,
    height: 1.933,
    transform: "translate(3855.677 1913.029)",
    fill: "#536169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3097",
    "data-name": "Rectangle 3097",
    width: 1.933,
    height: 1.933,
    transform: "translate(3857.609 1914.962)",
    fill: "#536169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3098",
    "data-name": "Rectangle 3098",
    width: 1.933,
    height: 1.933,
    transform: "translate(3855.677 1916.894)",
    fill: "#536169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3099",
    "data-name": "Rectangle 3099",
    width: 1.933,
    height: 1.933,
    transform: "translate(3857.609 1918.827)",
    fill: "#536169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M3855.724,1921.65v1.925a1.925,1.925,0,1,0,3.85,0v-1.925Zm3.043,1.9a1.142,1.142,0,0,1-2.283,0v-.5h2.283Z",
    fill: "#536169"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M3858.414,1937.269l3.614-9.764h-3.071v-1.456h5.149v.977l-3.621,9.764h3.407v1.457h-5.478Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M3865.356,1926.049h1.85v12.2h-1.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M3869.292,1926.049h1.849c.234,0,.49.011.768.031a4.382,4.382,0,0,1,.836.15,3.189,3.189,0,0,1,.807.361,2.462,2.462,0,0,1,.689.661,3.392,3.392,0,0,1,.482,1.046,5.531,5.531,0,0,1,.182,1.528v.429a7.292,7.292,0,0,1-.167,1.675,4.353,4.353,0,0,1-.447,1.172,2.644,2.644,0,0,1-.646.76,2.875,2.875,0,0,1-.764.432,3.38,3.38,0,0,1-.8.192,6.44,6.44,0,0,1-.76.047h-.179v3.714h-1.849Zm1.942,7.127a2.141,2.141,0,0,0,.843-.147,1.184,1.184,0,0,0,.546-.457,2.142,2.142,0,0,0,.293-.8,6.58,6.58,0,0,0,.09-1.174v-1.1a4.915,4.915,0,0,0-.079-.939,1.518,1.518,0,0,0-.282-.654,1.206,1.206,0,0,0-.547-.382,2.553,2.553,0,0,0-.864-.125h-.093v5.778Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.769d3b109d5944b69d7e2cfd14585bfc.svg";
export { ForwardRef as ReactComponent };